import { type AssetCustomFieldValue } from '@air/api/types';

import { formatCustomFieldValueAsString } from '~/utils/CustomFields/formatCustomFieldValueAsString';

const escapeCsvValue = (value: string): string => {
  if (value.includes('"') || value.includes(',') || value.includes('\n') || value.includes('\r')) {
    return `"${value.replace(/"/g, '""')}"`;
  }
  return value;
};

export const buildCsvString = (fields: AssetCustomFieldValue[]): string => {
  const header = 'Field Name,Value';
  const rows = fields.map((field) => {
    const name = escapeCsvValue(field.name);
    const value = escapeCsvValue(formatCustomFieldValueAsString(field));
    return `${name},${value}`;
  });
  return [header, ...rows].join('\r\n');
};

export const downloadCustomFieldsCsv = (fields: AssetCustomFieldValue[], filename = 'custom-fields.csv') => {
  const csv = buildCsvString(fields);
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};
